import React from "react";
import { Button, Tooltip } from "antd";
import { SunOutlined, MoonOutlined } from "@ant-design/icons";
import { useAppearance } from "./contexts/AppearanceContext";

export default function AppearanceSwitch() {
  const { isDark, toggle } = useAppearance();
  return <Tooltip title={`${isDark ? 'Switch to light theme' : 'Switch to dark theme'} — applies to Sales Pipeline, Mail and Global Settings`} placement="bottom">
    <Button className="app-header-icon-button" type="text" role="switch" aria-label="Dark theme" aria-checked={isDark} icon={isDark ? <MoonOutlined /> : <SunOutlined />} onClick={toggle} />
  </Tooltip>;
}
